export const ApplicationNames = {
  HUB: 'Hub',
  LENS: 'Lens',
  PIXEL_RAD: 'Pixel Radiology',
  NEXT_PLATFORM: 'Next Platform',
  NEXT_INTELLIGENCE: 'Next Intelligence',
  TRIALS_APP: 'Trials App',
  PROGENY2: 'Progeny',
};
